import {
  ADMIN_MY_PRODUCTS_3DMODAL_V2,
  ADMIN_MY_PRODUCTS_ROOMS_V2,
  ADMIN_MY_PRODUCTS_TEXTURE_V2,
  ADMIN_MY_PRODUCTS_UPLOADS_V2,
  ADMIN_MY_PROJECTS_V2,
  ADMIN_MY_PROPS_V2,
  RENDERS_PREVIEWS_ROUTE_V2,
} from '../../config/constant/routePathConstant';
import { useEffect, useState } from 'react';
import { FilterItem } from './FilterItem';
import { MODEL_TYPES, SKIP_BRAND_FILTER_MODULE } from '../../constants/constants';
import {
  ADMIN_MY_PRODUCTS_MATERIAL_V2,
  TEMPLATES_ROUTE_V2,
} from '../../constants/routePathConstants';
import { dispatcher } from '../../helpers/projectHelper';
import { fetchAllPages } from '../../helpers/apiHelper';
import { getAppState } from '../../redux/store';
import { getSidefilters } from '../../helpers/api';
import {
  filterNotAvailableFilters,
  getFiltersPageNoByType,
  getOptimizeSidefilters,
  parseSidefilterParams,
  sortFilters,
} from '../../api/apiGenerator';
import { removeDuplicatesByKey } from '../../helpers/jsHelper';
import {
  selectFilteroptions,
  selectFilterValues,
  setFilterValue,
  sidebarActions,
} from '../../redux/slicers/admin/sidebarSlicer';
import { setLables } from '../../redux/slicers/admin/sidebarSlicer';
import styles from './SideFilter.module.scss';
import { useSearchParams } from 'react-router-dom';
import { useUserContext } from '../../contexts/UserContext';
import {
  selectFilterSearchValue,
  selectParamsInSequence,
} from '../../redux/slicers/filters/filterSlicer';
import { useDispatch, useSelector } from 'react-redux';
import { selectSearchTags } from '../../redux/slicers/search/searchSlicer';
import { paginatedProductActions } from '../../redux/slicers/admin/paginatedProductSlicer';
import { debounce } from 'lodash';

export const getModelTypeBasedOnParams = () => {
  const url = window.location.pathname;

  const routeMappings = {
    [RENDERS_PREVIEWS_ROUTE_V2]: MODEL_TYPES.PROJECTRENDER,
    [ADMIN_MY_PROJECTS_V2]: MODEL_TYPES.PROJECTS,
    [ADMIN_MY_PROPS_V2]: MODEL_TYPES.PRODUCT,
    [ADMIN_MY_PRODUCTS_3DMODAL_V2]: MODEL_TYPES.THREEDMODELS,
    [TEMPLATES_ROUTE_V2]: MODEL_TYPES.TEMPLATES,
    [ADMIN_MY_PRODUCTS_ROOMS_V2]: MODEL_TYPES.ROOM,
    [ADMIN_MY_PRODUCTS_TEXTURE_V2]: MODEL_TYPES.TEXTURE,
    [ADMIN_MY_PRODUCTS_UPLOADS_V2]: MODEL_TYPES.UPLOADS,
    [ADMIN_MY_PRODUCTS_MATERIAL_V2]: MODEL_TYPES.MATERIAL,
  };

  return routeMappings[url] || '';
};

export const updateFiltersInRedux = ({ type, response, updateInSelector }) => {
  const filtersData = selectFilteroptions(getAppState());

  let updatedType = type;
  if (!['collections', 'brands', 'props'].includes(updatedType)) {
    updatedType = 'filteroptions';
  }

  const updatedFilters = {
    ...filtersData,
    [updatedType]: [...filtersData[updatedType], ...response.results],
    otherDetails: {
      ...filtersData.otherDetails,
      [type]: {
        page: +response.current_page_number,
        total: response.count,
        total_pages: response?.total_pages,
      },
    },
  };

  dispatcher(setLables({ sidefilter: updatedFilters }));
  if (updateInSelector) {
    dispatcher(paginatedProductActions.setFilter(updatedFilters));
  }
};

export const updateFilterCollectionsByType = async (type = null) => {
  if (!type) return;

  const searchParams = new URLSearchParams(window.location.search);
  const _page = searchParams.get(`fp_${type}`) || 1;
  const modelType = getModelTypeBasedOnParams();

  // Make the API call to get side filters
  const response = await fetchAllPages(
    async (page) =>
      await getSidefilters({
        params: parseSidefilterParams({
          searchParams,
          type,
          page,
        }),
        type,
        modelType,
      }),
    _page
  );

  if (response && response.results) {
    // Update filters in Redux based on the type and labelId
    updateFiltersInRedux({
      type: type,
      response,
    });
  }
};

export const SideFilter = ({
  setSearchLoading,
  filters,
  maxVisible = 6,
  value,
  onChange,
  designV2 = null,
  handleClearAllFilter = () => {},
}) => {
  const {
    currentUser: { organization },
    isEditor,
    isGuestUser,
  } = useUserContext();
  const dispatch = useDispatch();
  const paramsInSequence = useSelector(selectParamsInSequence);
  const searchTagsList = useSelector(selectSearchTags);
  const filterSearchValue = selectFilterSearchValue(getAppState());
  const [_filters, setFilters] = useState([]);
  const [searchUrlParams, setSearchParams] = useSearchParams();

  const parseSidefilter = (sidefilter) => {
    const updatedFilters = Object.assign({}, sidefilter);
    const categoryIndex = updatedFilters.filterlabels.findIndex(
      (a) => a.label_name.toLowerCase() === 'categories'
    );
    if (categoryIndex !== -1) {
      updatedFilters.filteroptions = [
        {
          id: 'ua',
          name: 'Unassigned',
          filter_label: updatedFilters.filterlabels[categoryIndex]?.id,
        },
        ...sidefilter.filteroptions,
      ];
    }
    return updatedFilters;
  };

  useEffect(() => {
    if (!searchTagsList?.length && !value?.length && paramsInSequence?.length) {
      handleClearAllFilter?.(false);
    }
  }, []);

  // added the debounce to keep the wait in the api call
  useEffect(() => debounce(() => handleGetFilter(), 500), [filterSearchValue]);

  // this function update the sidefilter data when searching in the filters
  const handleGetFilter = async () => {
    const modelType = getModelTypeBasedOnParams();
    let skipBrandFilter = SKIP_BRAND_FILTER_MODULE.includes(+modelType);
    const searchParams = new URLSearchParams(window.location.search);
    setSearchLoading?.(true);
    const res = await getOptimizeSidefilters({ searchParams, modelType });
    setSearchLoading?.(false);
    if (res) {
      let sidefilter = {};
      const { _sidefilter, _filterlabels, _filteroptions } = res;
      const labelOptionObject = {};
      _filterlabels?.results.forEach((label) => {
        const id = label?.id;
        const label_name = label?.label_name;
        const isProductPageFilter = label?.is_product_page_filter; // we get this filter from the product / texture api only
        const option = _filteroptions?.filter(
          (item) => item.results?.[0]?.filter_label === id
        )?.[0];

        labelOptionObject[`${label_name}_${id}`] = {
          page: getFiltersPageNoByType(`${label_name}_${id}`) || +option?.current_page_number || 1,
          total: option?.count || 0,
          total_pages: option?.total_pages || 1,
          ...(isProductPageFilter
            ? {
                isProductPageFilter: true,
              }
            : {}),
        };
      });

      sidefilter = {
        filterlabels: _filterlabels?.results || [],
        collections: _sidefilter?.collections?.data || [],
        brands: skipBrandFilter ? [] : _sidefilter?.brands?.data || [],
        props: _sidefilter?.props?.data || [],
        filteroptions: _filteroptions.map((a) => a.results).flat() || [],
        order: ['collections', 'brands', 'filterlabels', 'filteroptions', 'props'],
        otherDetails: {
          collections: {
            ..._sidefilter?.collections,
            page: getFiltersPageNoByType('collections'),
          },
          brands: {
            ..._sidefilter?.brands,
            page: getFiltersPageNoByType('brands'),
          },
          props: {
            ..._sidefilter?.props,
            page: getFiltersPageNoByType('props'),
          },
          ...labelOptionObject,
        },
      };

      if (parseSidefilter) {
        sidefilter = parseSidefilter(sidefilter);
      }

      const sortedFilters = sortFilters(sidefilter);
      dispatch(sidebarActions.setFilters(sortedFilters));

      const filterValues = selectFilterValues(getAppState());
      // some of the filters might not be available after fetching data -> so we need to remove them from selected filters
      const newFilterValues = filterNotAvailableFilters(filterValues, sidefilter);
      if (filterValues.length !== newFilterValues.length) {
        dispatch(setFilterValue(newFilterValues));
      }
      dispatch(setLables({ sidefilter }));
    }
  };

  // Function to handle view more functionality
  const createViewMoreFunction = async ({ title, type, page = 1, labelId } = {}) => {
    // Generate parameters for the side filter API call
    const searchParams = new URLSearchParams(window.location.search);
    const params = parseSidefilterParams({ searchParams, type, page, labelId });
    const modelType = getModelTypeBasedOnParams();

    // Make the API call to get side filters
    const response = await getSidefilters({ params, type, modelType });

    if (response && response.results) {
      // Update filters in Redux based on the type and labelId
      updateFiltersInRedux({
        type: labelId ? `${title}_${labelId}` : type,
        response,
      });

      // Keeping filters page number in the url. So, that when the user reload the page we will get all the data till the page and show there filter selection
      const paramType = `fp_${labelId ? `${title.replaceAll(' ', '__')}_${labelId}` : type}`;
      searchUrlParams.set(paramType, page);
      setSearchParams(searchUrlParams);
    }
  };

  const updateFilters = () => {
    // Use all filters for editors and guest users; otherwise, include only 'visuals' or non-product page filters.
    const _filters =
      isEditor || isGuestUser()
        ? filters
        : filters?.filter(
            (a) => 'visuals' === a?.title?.trim()?.toLowerCase() || !a?.isProductPageFilter
          );

    const updatedFilters = [..._filters].map((a) => {
      if (getModelTypeBasedOnParams()) {
        if (a.title === 'Collections') {
          return {
            ...a,
            viewMore: async ({ page = 1 }) =>
              createViewMoreFunction({ title: a.title, type: 'collections', page }),
          };
        } else if (a.title === 'Brands') {
          return {
            ...a,
            viewMore: async ({ page = 1 }) =>
              createViewMoreFunction({ title: a.title, type: 'brands', page }),
          };
        } else if (a.title === 'My Products') {
          return {
            ...a,
            viewMore: async ({ page = 1 }) =>
              createViewMoreFunction({ title: a.title, type: 'props', page }),
          };
        } else if ('page' in a && !['Collections', 'Brands', 'My Products'].includes(a.title)) {
          return {
            ...a,
            viewMore: async ({ labelId, page = 1 }) =>
              createViewMoreFunction({ title: a.title, type: 'filterOptions', page, labelId }),
          };
        }
      }

      return a;
    });

    setFilters(updatedFilters.filter(Boolean));
  };

  useEffect(() => {
    updateFilters();
  }, [filters]);

  return (
    <div className={styles.root}>
      {_filters.map((filter, idx) => {
        const { title, items: _items, page, total, total_pages, viewMore } = filter;
        const items = removeDuplicatesByKey(_items, 'value');

        if (
          title &&
          title?.toLowerCase() === 'brands' &&
          items?.length === 1 &&
          items?.[0].value.slice(6) === organization.toString()
        ) {
          return null;
        }

        return (
          <FilterItem
            key={idx}
            designV2={designV2}
            title={title}
            items={items}
            value={value}
            onChange={onChange}
            maxVisible={maxVisible}
            viewMore={viewMore}
            page={page}
            total={total}
            total_pages={total_pages}
          />
        );
      })}
    </div>
  );
};
